<div class="container-fluid">
<div class="row">

<div class="col-md-6">
<app-intervention [showHeading]="false"></app-intervention>
</div>
<div class="col-md-6">
    <app-intervention-b></app-intervention-b>
</div>
</div>
</div>
